import { amortizeFrench } from './french.js';
import { amortizeGerman } from './german.js';
import type { AmortizationInput, AmortizationResult } from './types.js';

/**
 * Single entry point for the amortization engine.
 *
 * Pure: no I/O, no globals. Imported by both the SPA (live preview) and the
 * API (authoritative computation). All outputs are deterministic given the
 * same input — this is the contract that lets us golden-test against the
 * client's signed Excel examples.
 */
export function amortize(input: AmortizationInput): AmortizationResult {
  switch (input.method) {
    case 'french':
      return amortizeFrench(input);
    case 'german':
      return amortizeGerman(input);
  }
}
